module.exports = __webpack_public_path__ + "static/img/zip.f6942e60.png";